import {usePlantConfigQuery} from '../hooks/api'

export const usePlantConfig = () => {
  const {data: plantConfig} = usePlantConfigQuery()
  if (!plantConfig) throw new Error('Plant config data is not available')
  return plantConfig
}
